import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, Form } from 'redux-form';

import { TextField } from 'common/components/forms';
// eslint-disable-next-line import/no-cycle
import { FormErrorNoRouter } from 'common/components/layout';
import { magicLink } from 'redux/customer/actions';

import { validateMagicLink } from './validators';

class MagicLinkWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessage: null,
      email: null
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    const { redirectLink } = this.props;
    const data = transformData(form);
    const successFunction = () => {
      this.setState({ showMessage: 'Success', email: data.email });
    };
    const errorFunction = () => {
      this.setState({ showMessage: 'Error' });
    };
    data.redirectLink = redirectLink;
    props.magicLink(data, successFunction, errorFunction);
    props.reset();
  };

  handleChange = () => {
    this.setState({ showMessage: null });
  };

  handleLogin = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onLogin();
  };

  render() {
    const { handleSubmit, form } = this.props;
    const { showMessage, email } = this.state;
    if (showMessage === 'Success') {
      return (
        <>
          <div className="c7-message--success">
            An email is on its way. <br />
            We sent an email to <strong>{email}</strong>. This link expires in 4
            hours so be sure to use it soon.
          </div>
          <a onClick={this.handleLogin}>Return to login</a>
        </>
      );
    }
    return (
      <>
        {showMessage === 'Error' && (
          <div className="c7-message--error">
            Error: No account found with that email.
          </div>
        )}
        <p>
          Long password? Hard to type? We can email you a magic link so you can
          sign in without having to type your password.
        </p>
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <FormErrorNoRouter formName={form} />
          <Field
            name="email"
            label="Email"
            component={TextField}
            autocomplete="email"
            formType="email"
            onChange={this.handleChange}
            required
          />
          <div>
            <button type="submit" className="c7-button">
              Send me a link
            </button>
          </div>
        </Form>

        <a onClick={this.handleLogin}>Return to login</a>
      </>
    );
  }
}

const transformData = (values) => {
  const data = {
    email: values.email
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateMagicLink(data);
  return errors;
};

MagicLinkWidget = reduxForm({
  form: 'magicLink',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(MagicLinkWidget);

export default connect(null, {
  magicLink
})(MagicLinkWidget);
